import httpClient from '@/shared/http-eserv-client';

const getInvoiceByRequestId = (requestId) => httpClient.get(`/Invoices/GetPayableInvoiceByRequestId?requestid=${requestId}`);
const requestPay = (order) => httpClient.post('/invoices/pay', order);
const postRequestInvoice = (data) => httpClient.post('/applicationrequests/invoice', data);
const getShoppingCartByUserId = (userId) => httpClient.get(`/ShoppingCarts/${userId}?$top=1&$filter=status eq 'InPrograss'&$expand=shoppingCartItems($expand=CartInvoice)`);
const getShoppingCartPaymentMethods = () => httpClient.get('/ShoppingCarts/PaymentMethods');
const removeInvoiceFromShoppingCart = (invoiceId) => httpClient.delete(`/ShoppingCartItems/${invoiceId}`);
const postInvoiceToShoppingCartById = (invoiceId) => httpClient.post(`/ShoppingCartItems/AddInvoiceToShoppingCartById?invoiceId=${invoiceId}`);
const postShoppingCart = (data) => httpClient.post('/ShoppingCarts', data);
const getInvoicePaymentMethods = (invoiceId) => httpClient.get(`/Invoices/PaymentMethods?invoiceId=${invoiceId}`);

export {
  getInvoiceByRequestId,
  postRequestInvoice,
  requestPay,
  getShoppingCartByUserId,
  getShoppingCartPaymentMethods,
  removeInvoiceFromShoppingCart,
  postInvoiceToShoppingCartById,
  postShoppingCart,
  getInvoicePaymentMethods,
};
